import rp from "@reporting/rp-app-host";
import { ReportContext } from "@reporting/rp-types/analytics";
import { ReportContainer } from "../components";
import { AnalyticsApplication } from "..";

const app = () => rp.applications.get<AnalyticsApplication>('analytics');

export type ReportTarget = 'active_tab'|'new_tab'|'dialog';

export type OpenReportOptions = {
	target: ReportTarget,
	title?: string,
	context?: ReportContext
}

export async function openReport(idContext: number, options?: OpenReportOptions): Promise<ReportContainer> {
	options = Object.assign({
		target: 'active_tab',
		context: null
	}, options || {}) as OpenReportOptions;

	let container: ReportContainer;
	const componentId = `analytics-reportContainer-${idContext}`;
	// replace the active container (every context type shares the
	// reportContainer id). Only one the host actually has - with a stale
	// active id the host would create (and immediately rename) a container
	// for the old context and open it in a new tab
	const active = options.target == 'active_tab' ? app().getReportContainer(app().activeIdContext) : null;
	const replaceId = active?.componentId ?? null;

	// if (replaceId == componentId) {
	// 	return rp.host.components.get(componentId) as ReportContainer;
	// }

	if (options?.target == 'dialog') {
		const dialog = await rp.host.openDialog({id: componentId});
		container = dialog.component as ReportContainer;
	} else {
		container = await (rp.host.open(componentId, {
			title: options?.title ?? `#${idContext}`,
			replace: replaceId,
			//preventDisconnect: true,
		})) as ReportContainer;

		if (replaceId) {
			// the replace flow reuses the previous container instance (the tab
			// is renamed, no factory runs) - reset it for the new context
			app().activeIdContext = idContext;
			const reportContext = await app().contextBroker.getContext({id_context: idContext});
			const store = app().getOrCreateReportStore(reportContext);
			await container.openContext(reportContext, store);
		}
	}

	return container;
}
